import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { FaUser, FaGlobe, FaBuilding, FaMapMarkerAlt } from 'react-icons/fa';
import './ProfilePage.css';

function PublicProfilePage() {
  const { username } = useParams();
  const [profileData, setProfileData] = useState(null);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchUserData();
  }, [username]);

  const fetchUserData = async () => {
    try {
      // Find user by username
      const usersRef = collection(db, 'users');
      const q = query(usersRef, where('username', '==', username));
      const userSnapshot = await getDocs(q);

      if (userSnapshot.empty) {
        setError('User not found');
        setLoading(false);
        return;
      }

      const userData = userSnapshot.docs[0].data();
      const userId = userSnapshot.docs[0].id;

      // Fetch user's public projects
      const projectsRef = collection(db, 'projects');
      const projectsQuery = query(
        projectsRef,
        where('userId', '==', userId),
        where('isPublic', '==', true)
      );
      
      const projectsSnapshot = await getDocs(projectsQuery);
      const projectsData = projectsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setProfileData(userData);
      setProjects(projectsData);
    } catch (error) {
      setError('Error loading profile');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error-message">{error}</div>;
  if (!profileData) return <div>Profile not found</div>;

  return (
    <div className="profile-page">
      <div className="profile-container">
        <div className="profile-sidebar">
          <div className="profile-avatar">
            <FaUser size={60} />
            <h2>{profileData.displayName}</h2>
            <p className="username">@{profileData.username}</p>
          </div>
        </div>

        <div className="profile-content">
          <div className="profile-info">
            <div className="info-section">
              <h3>About</h3>
              <p>{profileData.bio || 'No bio provided'}</p>
            </div>

            {profileData.website && (
              <div className="info-item">
                <FaGlobe />
                <a href={profileData.website} target="_blank" rel="noopener noreferrer">
                  {profileData.website}
                </a>
              </div>
            )}

            {profileData.company && (
              <div className="info-item">
                <FaBuilding />
                <span>{profileData.company}</span>
              </div>
            )}

            {profileData.location && (
              <div className="info-item">
                <FaMapMarkerAlt />
                <span>{profileData.location}</span>
              </div>
            )}
          </div>

          <div className="projects-section">
            <h2>Public Projects</h2>
            <div className="projects-grid">
              {projects.map(project => (
                <div key={project.id} className="project-card">
                  <h3>{project.title || 'Untitled Project'}</h3>
                  <p className="project-date">
                    {new Date(project.createdAt).toLocaleDateString()}
                  </p>
                  <div className="preview">{project.lastMessage}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PublicProfilePage;